import React, { useState } from "react";
import "../styles/Graphic.css";

// Asset Imports
import poster1 from "../../assets/poster/poster1.webp";
import poster2 from "../../assets/poster/poster2.webp";
import poster3 from "../../assets/poster/poster3.webp";
import poster4 from "../../assets/poster/poster4.webp";
import poster5 from "../../assets/poster/poster5.webp";
import poster6 from "../../assets/poster/poster6.webp";
import poster7 from "../../assets/poster/poster7.webp";

import bak1 from "../../assets/bak1.webp";
import bak2 from "../../assets/bak2.webp";
import bak3 from "../../assets/bak3.webp";
import bak4 from "../../assets/bak4.webp";

import verd1 from "../../assets/verd/verd1.webp";
import verd2 from "../../assets/verd/verd2.webp";
import verd3 from "../../assets/verd/verd3.webp";
import verd4 from "../../assets/verd/verd4.webp";
import verd5 from "../../assets/verd/verd5.webp";
import verd6 from "../../assets/verd/verd6.webp";
import verd7 from "../../assets/verd/verd7.webp";

const GRAPHIC_PROJECTS = {
  bakery: {
    titlePrefix: "Bakery Brand",
    titleItalic: "Identity",
    subtitle:
      "A warm and inviting visual identity built around bakery themes, featuring a soft pastel color palette, typography, and brand styling.",
    ctaText: "Explore Project",
    ctaLink: "https://www.behance.net/gallery/217857087/Petty-Pastries-Branding-Design",
    images: [bak1, bak2, bak3, bak4],
  },

  verd: {
    titlePrefix: "Verdance Brand",
    titleItalic: "Identity",
    subtitle:
      "A complete visual identity of a sustainable packaging brand for a freelance client, including brochures, festive campaigns, marketing creatives, and digital design assets.",
    ctaText: "View Project",
    ctaLink: "https://www.behance.net/gallery/241861561/Brand-Identity-Design-Creatives-Brochure-Design",
    images: [verd1, verd2, verd3, verd4, verd5, verd6, verd7],
  },

  poster: {
    titlePrefix: "Poster",
    titleItalic: "Collection",
    subtitle:
      "A collection of modern product posters crafted to showcase brands through bold layouts and premium visuals, maintaining a cohesive visual identity for marketing campaigns.",
    ctaText: "View Designs",
    ctaLink: "https://www.behance.net/gallery/249924933/Poster-Designs-Portfolio",
    images: [poster1, poster2, poster3, poster4, poster5, poster6, poster7],
  },
};

export default function Graphics({ project, onBack }) {
  const data = GRAPHIC_PROJECTS[project] || {
    titlePrefix: "Project",
    titleItalic: "Detail",
    subtitle: "",
    ctaText: "Explore Project",
    ctaLink: "#",
    images: [],
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const baseImages = data.images;
  const displayImages =
    baseImages.length > 0 && baseImages.length < 5
      ? [...baseImages, ...baseImages]
      : baseImages;

  const total = displayImages.length;

  return (
    <div className="graphics-detail-page">
      {/* Back Button */}
      <button className="back-btn" onClick={onBack} aria-label="Go Back">
        <span className="arrow">←</span>
      </button>

      {/* Top Header Section */}
      <div className="graphics-header-block">
        <h1 className="graphics-hero-title">
          {data.titlePrefix} <span className="title-italic">{data.titleItalic}</span>
        </h1>
        {data.subtitle && <p className="graphics-hero-subtext">{data.subtitle}</p>}
      </div>

      {/* 3D Black Scroller Deck Stage */}
      <div className="coverflow-stage-pod">
        <div className="coverflow-track">
          {displayImages.map((src, index) => {
            let offset = (index - activeIndex) % total;
            if (offset > total / 2) offset -= total;
            if (offset < -total / 2) offset += total;

            const isCenter = offset === 0;
            const absOffset = Math.abs(offset);

            // Exactly 2 cards on left and right
            const isVisible = absOffset <= 2.2;
            const scale = isCenter ? 1 : Math.max(0.74, 1 - absOffset * 0.12);
            const zIndex = 30 - Math.round(absOffset * 5);
            const rotateY = isCenter ? 0 : offset > 0 ? -22 : 22;

            // Stepped brightness: 100% center -> 72% immediate neighbors -> 46% outer
            const brightness = isCenter ? 1 : absOffset <= 1.2 ? 0.72 : 0.46;

            return (
              <div
                key={index}
                className={`coverflow-item ${isCenter ? "active" : ""}`}
                style={{
                  "--offset-factor": offset,
                  "--scale-factor": scale,
                  "--rotate-y": `${rotateY}deg`,
                  "--card-brightness": brightness,
                  zIndex: zIndex,
                  display: isVisible ? "block" : "none",
                }}
                onClick={() => setActiveIndex(index)}
              >
                <img
                  src={src}
                  alt={`${data.titlePrefix} ${index + 1}`}
                  className="coverflow-card-img"
                  loading={isCenter ? "eager" : "lazy"}
                  decoding="async"
                  fetchPriority={isCenter ? "high" : "auto"}
                  width="266"
                  height="355"
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Bottom Destination CTA Button */}
      <div className="graphics-cta-wrapper">
        <a
          href={data.ctaLink}
          target="_blank"
          rel="noreferrer"
          className="graphics-main-btn"
        >
          {data.ctaText}
        </a>
      </div>
    </div>
  );
}